<div class="view-as-container">
  <div class="view-as-data">
    <span> Filtered By: </span>
    <ul>
      <ng-container *ngIf="partner || company; else All">
        <li *ngIf="partner">Partner: {{ partner?.name }}</li>
        <li *ngIf="company">Company: {{ company?.name }}</li>
      </ng-container>
      <ng-template #All>
        <li class="text-bolder">All</li>
      </ng-template>
    </ul>
  </div>

  <div class="view-as-action">
    <button
      *ngIf="null | applyFunctionOrValue: isResetFilterVisible; else setFilters"
      type="reset"
      [disabled]="!(null | applyFunctionOrValue: isResetFilterVisible)"
      (click)="resetFilter()"
      mat-button
      mat-raised-button
      color="warn"
      class="reset-btn"
    >
      Reset Filter
    </button>
    <ng-template #setFilters>
      <button type="button" (click)="showFilterModal()" mat-button mat-raised-button color="accent" class="reset-btn">
        Set Filter
      </button>
    </ng-template>
  </div>
</div>
